import React from 'react';
import { Modal } from '@brighterion/br-ui';
import { Trans, useTranslation } from 'react-i18next';
import useDeleteTenantGroup from 'Hooks/query-hooks/tenant-groups/useDeleteTenantGroup';
import { trackEvent, EventTypes, EventNames } from '@brighterion/insights';

import styles from './DeleteTenantGroupModal.css';

type DeleteTenantGroupModalProps = {
    closeModal: () => void;
    isOpen: boolean;
    tenantGroup: TenantGroup;
};

const DeleteTenantGroupModal = ({ closeModal, isOpen, tenantGroup }: DeleteTenantGroupModalProps) => {
    const { t } = useTranslation();
    const { name } = tenantGroup;
    const mutation = useDeleteTenantGroup({
        mutationOptions: {
            onSuccess: () => {
                closeModal();
            },
            onError: () => {
                closeModal();
            }
        }
    });

    const handleOnAction = () => {
        mutation.mutate(tenantGroup);
        trackEvent({
            eventType: EventTypes.track,
            eventName: EventNames.click,
            payload: {
                clickIdentifier: 'Tenant Groups - Delete Tenant Group',
                text: 'Delete Tenant Group'
            }
        });
    };

    return (
        <Modal closeModal={closeModal} dataTestId='delete-tenant-group-modal' isOpen={isOpen} status='warning'>
            <Modal.Title
                id='delete-tenant-group-title'
                title={t('Delete Tenant Group')}
                statusIcon='warning'
                onClose={closeModal}
            />
            <div className={styles.modalBody}>
                <div className={styles.content}>
                    <Trans i18nKey='errorHandling.tenantGroup.deleteTenantGroup'>
                        Are you sure you want to delete the tenant group <strong>{{ tenantGroupName: name }}</strong>?
                        All tenants and overrides associated with this group will be removed.
                        <br />
                        <br />
                        This action cannot be undone.
                    </Trans>
                </div>
            </div>
            <Modal.Footer
                disableOnAction={mutation.isLoading}
                disableOnCancel={mutation.isLoading}
                id='delete-tenant-group-footer'
                onAction={handleOnAction}
                onActionText={t('Delete Tenant Group')}
                onClose={closeModal}
                onCloseText={t('Cancel')}
            />
        </Modal>
    );
};

export default DeleteTenantGroupModal;
